import { DialogTemplate } from "src/app/_models/body"
import { InputFieldType } from "src/app/common/constants"

export const TaskTemplate = (taskIntervalType: Array<any>, rewards: Array<any>, TaskEventSelections: Array<any>, TaskActiveTypeSelections: Array<any>): DialogTemplate => {
    return {
        dialogTitle: 'Set Task',
        dialogFields: [
            {
                key: 'name',
                label: 'Name',
                type: InputFieldType.Text,
                size: 12,
                required: true
            },
            {
                key: 'description',
                label: 'Description',
                type: InputFieldType.Text,
                size: 12,
                required: true
            },
            {
                key: 'repeatingIntervalType',
                label: 'Repeating Interval Type',
                type: InputFieldType.Selector,
                size: 12,
                options: taskIntervalType,
                required: true
            },
            {
                key: 'prerequisiteTaskId',
                label: 'Prerequisite Task Id',
                type: InputFieldType.Text,
                size: 12,
            },
            {
                key: 'intervalAfterPrerequisiteTask',
                label: 'Interval After Prerequisite Task',
                type: InputFieldType.Selector,
                size: 12,
                options: taskIntervalType,
                required: true
            },
            {
                key: 'mmitaRewardId',
                label: 'Reward ID',
                type: InputFieldType.Selector,
                size: 12,
                options: rewards,
                required: true
            },
            {
                key: 'taskEvent',
                label: 'Task Event',
                type: InputFieldType.Selector,
                size: 12,
                options: TaskEventSelections,
                required: true
            },
            {
                key: 'activeType',
                label: 'Active Type',
                type: InputFieldType.Selector,
                size: 12,
                options: TaskActiveTypeSelections,
                required: true,
                isClearDisabled: true
            },
            {
                key: 'startAt',
                label: 'Start At (UTC)',
                type: InputFieldType.DateTimePicker,
                size: 16,
                showSeconds: true
            },
            {
                key: 'endAt',
                label: 'End At (UTC)',
                type: InputFieldType.DateTimePicker,
                size: 16,
                showSeconds: true
            },

        ]
    }
}
